import React from "react";
import bgHeader from "../../assets/images/Newsletter/images/bg-header.png";
import banner from "../../assets/images/Newsletter/Oct-2024/banner.png";
import sagar from "../../assets/images/Newsletter/images/sagar.jpg";
import SushilGujarathi from "../../assets/images/Newsletter/Oct-2024/Sushil-Gujarathi.jpg";
import BusinessQuote2 from "../../assets/images/Newsletter/Oct-2024/Business-quote-2.jpg";
import Snehakshirsagar from "../../assets/images/Newsletter/Oct-2024/Sneha-kshirsagar.jpg";
import Umang from "../../assets/images/Newsletter/Oct-2024/Umang.jpeg";
import joinees from "../../assets/images/Newsletter/Oct-2024/New-Joinee.jpg";
import city from "../../assets/images/Newsletter/images/city.png";
import fb1 from "../../assets/images/Newsletter/images/fb1.png";
import tw1 from "../../assets/images/Newsletter/images/tw1.png";
import ln1 from "../../assets/images/Newsletter/images/ln1.png";
import ig1 from "../../assets/images/Newsletter/images/ig1.png";
import yt1 from "../../assets/images/Newsletter/images/yt1.png";
import BusinessQuoteOne from "../../assets/images/Newsletter/images/Business-quote-1.jpg";
import caseStudy from "../../assets/images/Newsletter/Oct-2024/CDP_TATA.png";
import Dreamforce from "../../assets/images/Newsletter/Oct-2024/Dreamforce.jpg";
import Netcore from "../../assets/images/Newsletter/Oct-2024/Netcore.jpg";
import Awards from "../../assets/images/Newsletter/Oct-2024/Awards.jpg";
import LongServiceAward from "../../assets/images/Newsletter/Oct-2024/Long-Service-Award.jpg";
import EconomicGrowth from "../../assets/images/Newsletter/Oct-2024/Dubai-Economy.jpg";
import RoyalEnfield from "../../assets/images/Newsletter/Oct-2024/Royal-Enfield.jpg"
import TataMotors from "../../assets/images/Newsletter/Oct-2024/Tata-Motors.jpg"
import CLVWebinar from "../../assets/images/Newsletter/Oct-2024/CLV-webinar.jpg"
import DelhiEvent from "../../assets/images/Newsletter/Oct-2024/Delhi-Event.jpg"
import CapeTown from "../../assets/images/Newsletter/Oct-2024/Cape-Town.jpg"
import GarjeMarathi from "../../assets/images/Newsletter/Oct-2024/Garje-Marathi.jpg"
import Outing from "../../assets/images/Newsletter/Oct-2024/Outing(mahabaleshwar).jpg"
import BirthdayCelebration from "../../assets/images/Newsletter/Oct-2024/Birthday-Celebration.jpg"
import SpritualEvent from "../../assets/images/Newsletter/Oct-2024/Spritual-Event.jpg"

const October = () => {
  return (
    <>
      <>
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        {/*[if !mso]><!*/}
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        {/*<![endif]*/}
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <title>COMSENSE - NEWSLETTER October-2024</title>
        <link
          rel="shortcut icon"
          href="https://www.comsenseconsulting.com/images/ico/favicon.ico"
        />
        <style
          dangerouslySetInnerHTML={{
            __html:
              "\n    @import url(https://fonts.googleapis.com/css2?family=Cookie&display=swap);\n    @import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500&display=swap);\n\n    @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');\n\n    @font-face {\n      font-family: 'Century Gothic', sans-serif;\n      src: url(fonts/CenturyGothic.ttf);\n    }\n\n    html {\n      font-family: century-gothic, sans-serif;\n      font-family: \"Montserrat\", sans-serif;\n    }\n\n    .ReadMsgBody {\n      width: 100%;\n      background-color: #fff\n    }\n\n    .ExternalClass {\n      width: 100%;\n      background-color: #fff\n    }\n\n    .ExternalClass,\n    .ExternalClass div,\n    .ExternalClass font,\n    .ExternalClass p,\n    .ExternalClass span,\n    .ExternalClass td {\n      line-height: 100%\n    }\n\n    html {\n      width: 100%\n    }\n\n    body {\n      -webkit-text-size-adjust: none;\n      -ms-text-size-adjust: none;\n      margin: 0;\n      padding: 0;\n      font-family: 'Open Sans', Arial, Sans-serif !important;\n      font-family: \"Montserrat\", sans-serif !important;\n    }\n\n    table {\n      border-spacing: 0;\n      table-layout: fixed;\n      margin: 0 auto\n    }\n\n    table table table {\n      table-layout: auto\n    }\n\n    img {\n      display: block !important;\n      overflow: hidden !important\n    }\n\n    .yshortcuts a {\n      border-bottom: none !important\n    }\n\n    img:hover {\n      opacity: .9 !important\n    }\n\n    a {\n      color: red;\n      text-decoration: none\n    }\n\n    .textbutton a {\n      font-family: 'open sans', arial, sans-serif !important;\n      font-family: \"Montserrat\", sans-serif;\n    }\n\n    .btn-link a {\n      color: #fff !important\n    }\n\n    ul {\n      padding-inline-start: 20px\n    }\n\n    ol {\n      padding-inline-start: 20px\n    }\n\n    .mobile-responsive {\n      display: none\n    }\n\n    .image-reponsive {\n      float: left;\n      margin-left: 0;\n      margin-right: 25px;\n      margin-top: 10px\n    }\n\n    @media only screen and (max-width:640px) {\n      body {\n        margin: 0;\n        width: auto !important;\n        font-family: 'Open Sans', Arial, Sans-serif !important\n      }\n\n      .table-inner {\n        width: 90% !important;\n        max-width: 90% !important\n      }\n\n      .table-full {\n        width: 100% !important;\n        max-width: 100% !important;\n        text-align: center !important\n      }\n\n      #sagar img {\n        width: 50%\n      }\n\n      .mobile-responsive {\n        display: block\n      }\n\n      .desktop-view {\n        display: none\n      }\n\n      .image-reponsive {\n        float: unset;\n        margin: 0 auto 10px\n      }\n\n      @media only screen and (max-width:479px) {\n        body {\n          width: auto !important;\n          font-family: 'Open Sans', Arial, Sans-serif !important\n        }\n\n        .table-inner {\n          width: 90% !important;\n          text-align: center !important\n        }\n\n        .table-full {\n          width: 100% !important;\n          max-width: 100% !important;\n          text-align: center !important\n        }\n\n        u+.body .full {\n          width: 100% !important;\n          width: 100vw !important\n        }\n\n        #sagar img {\n          width: 50%\n        }\n      }\n    }\n  ",
          }}
        />
        <table
          className="full newsletter-emailer"
          width="100%"
          alignitems="center"
          cellSpacing={0}
          cellPadding={0}
        >
          <tbody>
            <tr>
              <td
                bgcolor="#333742"
                background={bgHeader}
                style={{
                  borderTop: "4px solid red",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
                align="center"
              >
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td
                        height={40}
                        valign="top"
                        style={{
                          fontFamily: "Open sans,arial,sans-serif",
                          fontSize: 10,
                          color: "#fff",
                          lineHeight: "24px",
                          textAlign: "center",
                        }}
                      >
                        If this newsletter is not displayed correctly, please{" "}
                        <a href="/" style={{ color: "#fff" }}>
                          <u>click here</u>
                        </a>
                        .
                      </td>
                    </tr>
                    {/* <tr>
                      <td align="center">
                        <table
                          className="table-full"
                          align="centre"
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                        >
                          <tbody>
                            <tr>
                              <td align="center" style={{ lineHeight: 0 }}>
                                <img
                                  editable=""
                                  label="image"
                                  style={{
                                    display: "block",
                                    lineHeight: 0,
                                    fontSize: 0,
                                    border: 0,
                                  }}
                                  src={logo}
                                  width={160}
                                  alt="logo"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr> */}
                    {/* <tr>
                      <td height={25} />
                    </tr> */}
                  </tbody>
                </table>
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td>
                        <img
                          editable=""
                          label="image"
                          style={{
                            display: "block",
                            lineHeight: 0,
                            fontSize: 0,
                            border: 0,
                          }}
                          src={banner}
                          width="100%"
                          alt="logo"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <repeater>
          <table
            className="full"
            align="center"
            bgcolor="#333742"
            width="100%"
            border={0}
            cellSpacing={0}
            cellPadding={0}
          >
            <tbody>
              <tr>
                <td align="center">
                  <table
                    className="table-full"
                    width={600}
                    style={{ maxWidth: 600 }}
                    border={0}
                    align="center"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr>
                        <td bgcolor="#FFFFFF" align="center">
                          <table
                            className="table-inner"
                            width={550}
                            border={0}
                            align="center"
                            cellPadding={0}
                            cellSpacing={0}
                          >
                            <tbody>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td>
                                  <table
                                    width={150}
                                    className="table-full"
                                    border={0}
                                    align="left"
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          id="sagar"
                                          align="center"
                                          style={{ lineHeight: 0 }}
                                        >
                                          <img
                                            src={sagar}
                                            alt="icon"
                                            style={{
                                              display: "block",
                                              lineHeight: 0,
                                              fontSize: 0,
                                              border: 0,
                                              width: 167,
                                            }}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  {/*[if (gte mso 9)|(IE)]>
                </td>
                <td>
                  <![endif]*/}
                                  <table
                                    width={25}
                                    align="left"
                                    border={0}
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td height={15} />
                                      </tr>
                                    </tbody>
                                  </table>
                                  {/*[if (gte mso 9)|(IE)]>
                </td>
                <td>
                  <![endif]*/}
                                  <table
                                    className="table-full"
                                    width={375}
                                    border={0}
                                    align="right"
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td height={90} />
                                      </tr>
                                      <tr>
                                        <td
                                          align="center"
                                          style={{
                                            border: "0 solid #fff",
                                            borderRadius: 4,
                                          }}
                                        >
                                          <table
                                            width="90%"
                                            border={0}
                                            align="center"
                                            cellPadding={0}
                                            cellSpacing={0}
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  valign="bottom"
                                                  style={{
                                                    fontFamily:
                                                      "Century gothic,arial,sans-serif",
                                                    fontSize: 24,
                                                    color: "#4a4a4a",
                                                    fontWeight: 100,
                                                    lineHeight: "30px",
                                                  }}
                                                >
                                                  From the CEO’s Desk
                                                </td>
                                              </tr>
                                              <tr>
                                                <td height={10} />
                                              </tr>
                                              <tr>
                                                <td align="left">
                                                  <table
                                                    align="left"
                                                    width={30}
                                                    border={0}
                                                    cellSpacing={0}
                                                    cellPadding={0}
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          height={10}
                                                          style={{
                                                            borderBottom:
                                                              "3px solid red",
                                                          }}
                                                        />
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td height={20} />
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td height={20} />
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "24px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Dear Readers,
                                              <br />
                                              <br />
                                              As we wrap up the first half of
                                              the year, I want to take a moment
                                              to reflect on our progress. The
                                              past two quarters have been marked
                                              by success, thanks to the hard
                                              work of our dedicated team and the
                                              strong support from our clients.
                                              Together, we’ve achieved excellent
                                              results, and I couldn’t be
                                              prouder of what we’ve accomplished
                                              so far.
                                              <br />
                                              <br />
                                              Looking ahead, we are doubling
                                              down on our strategic focus
                                              around{" "}
                                              <strong>Salesforce Data Cloud</strong>{" "}
                                              and{" "}
                                              <strong>Marketing Cloud</strong>.
                                              These partnerships are opening new
                                              growth opportunities and further
                                              strengthening our position in the
                                              market. Alongside this,{" "}
                                              <strong>Agentic AI</strong> is
                                              becoming a crucial pillar of our
                                              strategy. Our teams are actively
                                              upskilling to stay ahead of the
                                              curve and bring AI-powered,
                                              outcome-driven solutions to our
                                              customers.
                                              <br />
                                              <br />
                                              I am also delighted to welcome{" "}
                                              <strong>
                                                10 new college graduates from
                                                C-DAC
                                              </strong>{" "}
                                              to the Comsense family. Their
                                              fresh perspectives, energy, and
                                              passion will play an important
                                              role as we scale our delivery and
                                              innovation capabilities.
                                              <br />
                                              <br />
                                              <strong>
                                                Key Initiatives and Focus Areas
                                              </strong>
                                              <br />
                                              We continue to strengthen our
                                              foundations through three
                                              signature programs:
                                              <br />
                                              <br />
                                              <strong>Customer Delight Program:</strong>{" "}
                                              Elevating customer satisfaction
                                              with tailored, memorable
                                              experiences that go beyond
                                              expectations.
                                              <br />
                                              <strong>Employee Delight Program:</strong>{" "}
                                              Fostering a culture of
                                              recognition, innovation, and
                                              growth that empowers our teams to
                                              thrive.
                                              <br />
                                              <strong>Centre of Excellence:</strong>{" "}
                                              Building out our COE to drive best
                                              practices, accelerate innovation,
                                              and ensure we consistently deliver
                                              world-class Salesforce and data
                                              solutions.
                                              <br />
                                              <br />
                                              By investing in these areas, we
                                              are strengthening relationships,
                                              deepening client loyalty, and
                                              creating an environment where our
                                              people can do their best work.
                                              <br />
                                              <br />
                                              As we prepare for the next
                                              quarter, our focus remains on
                                              driving growth, expanding our
                                              impact, and delivering even
                                              greater value to our clients in an
                                              increasingly dynamic landscape.
                                              Each of you plays a crucial role
                                              in this journey, and I’m confident
                                              that together, we will continue to
                                              move closer to our long-term
                                              vision.
                                              <br />
                                              <br />
                                              Let us continue to embrace change,
                                              stay focused, and remain committed
                                              to our mission.
                                              <br />
                                              <br />
                                              Happy Reading,
                                              <br />
                                              <br />
                                              <strong>Sagar Babar</strong>
                                              <br />
                                              <strong>CEO and Co-Founder</strong>
                                              <br />
                                              <strong>Comsense Technologies</strong>
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Won Deals
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  Comsense Technologies Chosen to Aid Data-Driven Strategies for Dubai’s Economic Growth
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={EconomicGrowth}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >


                                                We are super proud of our win for a project by one of the key commerce wings under the Dubai government. Our team will be building comprehensive and visually engaging dashboards to provide stakeholders with critical insights into major economic indicators. These dashboards will play a pivotal role in informing decision-makers and driving data-driven strategies for Dubai's economic growth.

                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  <strong>
                                                    A Leading Indian Motorcycle Manufacturing Company Entrusted Us with Elevating Their Customer Engagement and Marketing Success  </strong>
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={
                                                RoyalEnfield
                                              }
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                The company awarded us a project for Salesforce Marketing and Data Cloud Managed Services, where we're focusing on optimizing Customer Lifecycle Management journeys. Our role involves creating the most effective customer segments for targeted campaigns, driving personalized experiences across web and mobile platforms, and enhancing Customer Lifetime Value (CLV). This partnership allows us to leverage Salesforce to deliver tailored solutions that elevate customer engagement and overall marketing success for this client.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  Comsense Wins Managed Services Project from A Leading Indian Automobile Manufacturer
                                                </strong>
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={TataMotors}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                We are delighted to inform you that we have bagged a Managed Services project from one of our existing clients. The scope of the project includes MS for the implementation of seven key use cases utilizing Salesforce Marketing Cloud (SFMC) and Marketing Cloud Personalization. We are working around creating personalized customer journeys, driving deeper engagement, and enhancing our customer’s overall marketing effectiveness through data-driven solutions. This collaboration highlights our commitment to delivering impactful, scalable results through Salesforce's cutting-edge technologies.
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>


                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          <layout label="quote">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      className="table-full"
                      width={600}
                      style={{ maxWidth: 600 }}
                      border={0}
                      align="center"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td bgcolor="#FFFFFF" align="center">
                            <table
                              className="table-inner"
                              width={550}
                              style={{ maxWidth: 550 }}
                              border={0}
                              align="center"
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td
                                    style={{ border: "2px solid #d2d2d2" }}
                                    align="center"
                                  >
                                    <table
                                      className="table-inner"
                                      width={500}
                                      border={0}
                                      align="center"
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              className="table-full"
                                              width={375}
                                              border={0}
                                              align="left"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    style={{
                                                      fontFamily:
                                                        "Open sans,arial,sans-serif",
                                                      fontSize: 16,
                                                      color: "#9b9b9b",
                                                      lineHeight: "28px",
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    <multiline label="quote">
                                                      <i>
                                                        “You don’t build a
                                                        business, you build
                                                        people, then people
                                                        build the business.”{" "}
                                                      </i>
                                                      <br />
                                                      <br />
                                                      <br />
                                                      <span
                                                        style={{
                                                          color: "#9b9b9b",
                                                          fontFamily:
                                                            "Century Gothic",
                                                          fontSize: 14,
                                                          fontStyle: "normal",
                                                          fontWeight: 700,
                                                          lineHeight: "normal",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            color: "#000",
                                                            fontFamily:
                                                              "Century Gothic",
                                                            fontSize: 14,
                                                            fontStyle: "normal",
                                                            fontWeight: 700,
                                                            lineHeight:
                                                              "normal",
                                                          }}
                                                        >
                                                          - Zig Ziglar,
                                                        </span>{" "}
                                                        American Motivational
                                                        Speaker
                                                      </span>
                                                    </multiline>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                            <table
                                              width={25}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                              align="left"
                                            >
                                              <tbody>
                                                <tr>
                                                  <td height={10} />
                                                </tr>
                                              </tbody>
                                            </table>
                                            <table
                                              className="table-full"
                                              width={100}
                                              border={0}
                                              align="right"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      src={BusinessQuoteOne}
                                                      alt="img"
                                                      width={100}
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                      }}
                                                      editable=""
                                                      label="image"
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/*  */}

          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <br />
                                    <br />
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Business News/Events
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            CLV Webinar – A Collaboration with Theta and Peter Fader
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={CLVWebinar}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Last quarter, we partnered with Theta and renowned CLV expert Peter Fader for an insightful webinar on Maximizing Customer Lifetime Value. The session highlighted the latest strategies in CLV optimization, featuring the success story of a leading sports retail brand. Through our CLV models and strategies, the brand significantly boosted both sales and customer retention. The webinar offered a deep dive into the practical application of CLV in driving customer success and long-term value creation.

                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Dreamforce 2024 – Our Dream Event of The Year, Attended with Full Enthusiasm
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Dreamforce}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">


                                              Our co-founders, Sagar and Biju recently attended Dreamforce 2024 in San Francisco. There they connected with fellow Trailblazers and explored the latest in AI and data. The two also hosted brain dates on Data Cloud implementation, showcasing the important steps involved in implementing a CDP. They further showcased how CDP has become an important aspect of hyper-personalizing customer experience. The event focused on transforming businesses into AI-driven enterprises, with invaluable insights from Salesforce experts and industry leaders worldwide. As always, it was exhilarating to attend this event.

                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={35} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Our CEO, Sagar Babar, showcased CDP at the Netcore Global Martech Summit in Las Vegas and Baku.
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={
                                                Netcore
                                              }
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Our co-founders, Sagar and Biju attended the Netcore Global Martech Summit in Las Vegas and Baku, where the spotlight was on building lifelong customer relationships using the power of Generative AI. Both events featured hands-on demos, dynamic networking opportunities, and insightful discussions that redefined customer engagement and marketing innovation. Sagar delivered a comprehensive overview and live demo of the Customer Data Platform, showcasing how practical data utilization can revolutionize customer interactions.
                                              <br />
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height="25"></td>
                                        </tr>


                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Salesforce & Comsense Retail Event – Delhi
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={
                                                DelhiEvent
                                              }
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Last quarter, we hosted the exclusive Retail Innovation 360: Future of Data-Driven Retail event in collaboration with Solveda and Salesforce at Aerocity, Delhi. This invite-only event brought together C-suite leaders from the Marketing, Data, Digital, CRM, eCommerce, and Customer Experience sectors within the retail industry. The focus was on how Data & AI are revolutionizing retail customer experiences. Highlights included Sushil, our Chief Growth Officer, participating in a panel discussion on Data and AI-driven solutions for brands, while Vineet, our CFO, hosted a fireside chat with Abhishek Sinha on leveraging data to supercharge customer lifetime value. The event provided a valuable platform to demonstrate our Salesforce expertise and explore exciting new business opportunities!
                                              <br />
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height="25"></td>
                                        </tr>


                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Client Workshop Visit – Cape Town
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={
                                                CapeTown
                                              }
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Our Data Evangelist, Vishnu Kamath, recently led a productive client workshop in Cape Town, South Africa. Vishnu, who is also the BU Head for Data & BI, collaborated with a leading homeware and gift retailer to implement a cutting-edge Customer Data Platform (CDP). His expert recommendations focused on data discovery, dashboarding, and optimizing data strategies. Vishnu’s insights are helping the client harness the full potential of their data, driving better decision-making and improved business outcomes.
                                              <br />
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height="25"></td>
                                        </tr>


                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Garje Marathi Excellence Summit – New Jersey, August 2024
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={
                                                GarjeMarathi
                                              }
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Our co-founder, Sagar, was honored to speak at the Garje Marathi Excellence Summit at the NJ Convention & Exposition Centre in New Jersey on August 3rd and 4th, 2024. This global event celebrated the achievements of Marathi people worldwide. Entrepreneurs, executives, and students gathered to network and learn, with investment forums and success stories offering valuable insights.    <br />
                                              <br />
                                              Sagar’s keynote covered two captivating topics:
                                              <br /><br />
                                              <strong style={{ fontStyle: 'italic' }}>● Breaking Free from 9-to-5:</strong> How he transformed from a traditional job into the exhilarating, 24/7 hustle of entrepreneurship.
                                              <br></br><br></br>
                                              <strong style={{ fontStyle: 'italic' }}>● Leveraging LinkedIn for Success:</strong> Insights on how personal branding through LinkedIn shaped his career and empowered him to connect and thrive in the business world.
                                              <br></br><br></br>
                                              It was an impactful session that resonated with the audience!
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height="25"></td>
                                        </tr>
                                        <tr>
                                          <td height="25"></td>
                                        </tr>
                                        <tr>
                                          <td height="25"></td>
                                        </tr>


                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Case Study
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Check Out Our Latest Case Study
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                width: "100%",
                                                border:
                                                  "2px solid rgb(210, 210, 210)",
                                              }}
                                              src={caseStudy}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/*     <layout label=quote>
<table class=full bgcolor=#333742 align=center width=100% border=0 cellspacing=0 cellpadding=0>
  <tr>
    <td align=center>
      <table class=table-full width=600 style=max-width:600px border=0 align=center cellpadding=0 cellspacing=0>
        <tr>
          <td bgcolor=#FFFFFF align=center>
            <table class=table-inner width=550 style=max-width:550px border=0 align=center cellpadding=0
              cellspacing=0>

              <tr>
                <td height=25></td>
              </tr>
              <tr>
                <td height=25></td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
    </layout> */}
          {/* <layout label="1/1 content">
<table class=full bgcolor=#333742 align=center width=100% border=0 cellspacing=0 cellpadding=0>
  <tbody>
    <tr>
      <td align=center>
        <table align=center border=0 cellpadding=0 cellspacing=0>
          <tbody>
            <tr>
              <td width=600 align=center>
                <table class=table-full width=100% align=center border=0 cellpadding=0 cellspacing=0>
                  <tbody>
                    <tr>
                      <td bgcolor=#FFFFFF align=center style=text-align:center;vertical-align:top;font-size:0>
                        <table align=center width=90% border=0 cellspacing=0 cellpadding=0>
                          <tbody>
                            <tr>
                              <td height=25></td>
                            </tr>
                            <tr>
                              <td align=center width=580
                                style="font-family:Century gothic,arial,sans-serif;font-size:24px;color:#4a4a4a;font-weight:100;line-height:30px">
                                <singleline label=title>Case Studies </singleline>
                              </td>
                            </tr>
                            <tr>
                              <td height=20></td>
                            </tr>
                            <tr>
                              <td align=center>
                                <table width=40 bgcolor=#FF0000 style=border-radius:10px border=0 cellpadding=0
                                  cellspacing=0>
                                  <tbody>
                                    <tr>
                                      <td height=5 style=line-height:0;font-size:0px>&nbsp;</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <br>
                            <tr>
                              <td height=20></td>
                            </tr>
                            <tr>
                              <td width=580 align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:18px;color:red;line-height:28px;font-weight:700;text-align:center">
                                Comsense Quarterly Awards
                              </td>
                            </tr>
                            <tr>
                              <td height=25></td>
                            </tr>
                            <tr>
                              <td width=580 align=center style=line-height:0>
                                <img style=display:block;line-height:0;font-size:0px;border:0;width:100%
                                  src=images/awards.png alt=img width=100% height=auto>
                              </td>
                            </tr>
                            <tr>
                              <td height=10></td>
                            </tr>
                            <tr>
                              <td height=25></td>
                            </tr>
                            <tr>
                              <td align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                                <multiline label=content>Since we were unable to organize our Quarterly Award
                                  Ceremony in our previous quarter, we made it up by awarding people from two
                                  previous quarters together.<br></multiline>
                              </td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td align=left
                                style="font-family:Open sans,arial,sans-serif;font-size:16px;color:red;line-height:28px;font-weight:700;text-align:left">
                                Rookie (Rising Star) Award:
                              </td>
                            </tr>
                            <tr>
                              <td align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                                <multiline label=content>Comsense is always proud of its young and fresh team
                                  members who excel very early in their careers. This time our Rising star awards
                                  were given to <strong>Abhishek Sontakke, Sneha Kshirsagar, and Girish
                                    Sahare</strong> for their excellent performances in such early days of their
                                  span at Comsense.<br></multiline>
                              </td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td align=left
                                style="font-family:Open sans,arial,sans-serif;font-size:16px;color:red;line-height:28px;font-weight:700;text-align:left">
                                Star Performer Award:
                              </td>
                            </tr>
                            <tr>
                              <td align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                                <multiline label=content>Our best performers of the last two quarters were
                                  <strong>Anant Kadam, Shubham Chordia, and Soumy Dubey.</strong> They have gone
                                  beyond their roles to ensure Comsense’s success and thus rightly deserve the
                                  award. <br></multiline>
                              </td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td align=left
                                style="font-family:Open sans,arial,sans-serif;font-size:16px;color:red;line-height:28px;font-weight:700;text-align:left">
                                Ace Contributors:
                              </td>
                            </tr>
                            <tr>
                              <td align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                                <multiline label=content><strong>Rakhi Ankar</strong> was awarded the Ace
                                  Contributor award for being excellent in all roles and responsibilities given to
                                  her.<br></multiline>
                              </td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td align=left
                                style="font-family:Open sans,arial,sans-serif;font-size:16px;color:red;line-height:28px;font-weight:700;text-align:left">
                                Innovation Award:
                              </td>
                            </tr>
                            <tr>
                              <td align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                                <multiline label=content><strong>Suvaknata Rawat</strong> was awarded the
                                  innovation award for showcasing an excellent innovative approach towards problem
                                  solving and solutioning. <br></multiline>
                              </td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td height=25></td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
    </layout> */}
          <layout label="1/1 content">
            {/* <table class=full bgcolor=#333742 align=center width=100% border=0 cellspacing=0 cellpadding=0>
  <tr>
    <td align=center>
      <table align=center border=0 cellpadding=0 cellspacing=0>
        <tr>
          <td width=600 align=center>
            <table class=table-full width=100% align=center border=0 cellpadding=0 cellspacing=0>
              <tr>
                <td bgcolor=#FFFFFF align=center style=text-align:center;vertical-align:top;font-size:0>
                  <table align=center width=90% border=0 cellspacing=0 cellpadding=0>
                    <tr>
                      <td height=25></td>
                    </tr>
                    <tr>
                      <td width=580 align=center style=line-height:0>
                        <img style=display:block;line-height:0;font-size:0px;border:0;width:100%
                          src=images/five-years.png alt=img width=100% height=auto>
                      </td>
                    </tr>
                    <tr>
                      <td height=25></td>
                    </tr>
                    <tr>
                      <td align=center
                        style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                        <multiline label=content>
                          We were thrilled to honor Vishnu Kamath and Neerajkumar Gogavale with the Long Service
                          Award as they both completed 5 years with Comsense. We are thankful for their faith and
                          belief in the spirit of Comsense and wish them a long, fruitful journey ahead with us!
                          <br><br>
                        </multiline>
                      </td>
                    </tr>
                    <tr>
                      <td height=25></td>
                    </tr>
                    <tr>
                      <td height=20></td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table> */}
            {/* Client Testimonials */}
            <layout label="1/1 content">
              <table
                className="full"
                bgcolor="#333742"
                align="center"
                width="100%"
                border={0}
                cellSpacing={0}
                cellPadding={0}
              >
                <tbody>
                  <tr>
                    <td align="center">
                      <table
                        align="center"
                        border={0}
                        cellPadding={0}
                        cellSpacing={0}
                      >
                        <tbody>
                          <tr>
                            <td width={600} align="center">
                              <table
                                className="table-full"
                                width="100%"
                                align="center"
                                border={0}
                                cellPadding={0}
                                cellSpacing={0}
                              >
                                <tbody>
                                  <tr>
                                    <td
                                      bgcolor="#FFFFFF"
                                      align="center"
                                      style={{
                                        textAlign: "center",
                                        verticalAlign: "top",
                                        fontSize: 0,
                                      }}
                                    >
                                      <table
                                        align="center"
                                        width="90%"
                                        border={0}
                                        cellSpacing={0}
                                        cellPadding={0}
                                      >
                                        <tbody>
                                          <tr>
                                            <td height={10} />
                                          </tr>
                                          <tr>
                                            <td height={20} />
                                          </tr>
                                          <tr>
                                            <td height={30} />
                                          </tr>

                                          <tr>
                                            <td
                                              align="center"
                                              style={{
                                                fontFamily:
                                                  "Century gothic,arial,sans-serif",
                                                fontSize: 24,
                                                color: "#4a4a4a",
                                                fontWeight: 100,
                                                lineHeight: "30px",
                                              }}
                                            >
                                              <singleline label="title">
                                                Client Testimonial
                                              </singleline>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td height={20} />
                                          </tr>
                                          <tr>
                                            <td align="center">
                                              <table
                                                width={40}
                                                bgcolor="#FF0000"
                                                style={{ borderRadius: 10 }}
                                                border={0}
                                                cellPadding={0}
                                                cellSpacing={0}
                                              >
                                                <tbody>
                                                  <tr>
                                                    <td
                                                      height={5}
                                                      style={{
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                      }}
                                                    >
                                                      &nbsp;
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td height={25} />
                                          </tr>
                                          <tr>
                                            <td
                                              align="center"
                                              style={{
                                                fontFamily:
                                                  "Open sans,arial,sans-serif",
                                                fontSize: 14,
                                                color: "#9b9b9b",
                                                lineHeight: "28px",
                                                textAlign: "justify",
                                                border:
                                                  "2px solid rgb(210, 210, 210)",
                                                padding: "20px",
                                              }}
                                            >
                                              <multiline label="content">
                                                <p
                                                  style={{
                                                    fontFamily: "Open Sans",
                                                    fontSize: "14px",
                                                    color: "#9b9b9b",
                                                    lineHeight: "28px",
                                                    textAlign: "justify",
                                                  }}
                                                >
                                                  We have been thoroughly impressed with the services provided by the Comsense team. Their responsiveness and proactive approach to addressing our needs have been outstanding, with quick turnaround times and thorough assistance greatly enhancing our experience. The solutions offered are both robust and perfectly tailored to our requirements. Their attention to detail and innovative problem-solving approach have consistently exceeded our expectations. Additionally, the user-friendly interfaces and clear documentation have made transitions smooth and hassle-free. A standout moment was their swift and effective resolution of an integration issue during the implementation phase, which included a comprehensive walkthrough of the solution.
                                                  <br></br><br></br>
                                                  Overall, the exceptional quality of service and support from Comsense has made a significant positive impact on our operations. We highly recommend their services and look forward to continued collaboration.
                                                </p>
                                                <strong>
                                                  <i>
                                                    - Akshatha Shettigar – IT Business Analyst, Compass
                                                  </i>
                                                </strong>
                                              </multiline>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td height={25} />
                                          </tr>
                                          <tr>
                                            <td height={25} />
                                          </tr>
                                          <tr>
                                            <td height={25} />
                                          </tr>
                                          <tr>
                                            <td
                                              align="center"
                                              style={{
                                                fontFamily:
                                                  "Open sans,arial,sans-serif",
                                                fontSize: 14,
                                                color: "#9b9b9b",
                                                lineHeight: "28px",
                                                textAlign: "justify",
                                                border:
                                                  "2px solid rgb(210, 210, 210)",
                                                padding: "20px",
                                              }}
                                            >
                                              <multiline label="content">
                                                <p
                                                  style={{
                                                    fontFamily: "Open Sans",
                                                    fontSize: "14px",
                                                    color: "#9b9b9b",
                                                    lineHeight: "28px",
                                                    textAlign: "justify",
                                                  }}
                                                >
                                                  Umang and Team, Congratulations on a successful project handover!! Shout out to the Data Cloud implementation team especially! , @Vishnu Kamath @Ranjith Rajmohan @Shubham Bhosekar and @Niharika Vashishtha - great work overall taking this to closure, I know this was not easy to begin with.. we faced several blockers right from discovery. I appreciate the team's perseverance throughout several rounds of corrections & re-work. The team has run 10+ unification rules and validated cases by region and by category (B2B and Individual owners). @Vishnu Kamath, @Ranjith Rajmohan - Your experience with Python and data helped here to expedite the transformation and cleanup logic for large data sets run analysis for the spread, and point out the gaps. </p>
                                                <strong>
                                                  <i>
                                                    - Anusha Vrushabendraswamy | Lead Technical Architect, Strategic Accounts Excellence | Salesforce
                                                  </i>
                                                </strong>
                                              </multiline>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td height={25} />
                                          </tr>
                                          <tr>
                                            <td height={25} />
                                          </tr>
                                          <tr>
                                            {/* <td align=center
                        style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                        <multiline lable=content>
                          <strong>Umang and Team, Congratulations on a successful project handover!!</strong>
                          <p>Shout out to the Data Cloud implementation team especially! , @Vishnu Kamath
                            @Ranjith Rajmohan @Shubham Bhosekar and @Niharika Vashishtha - great work overall
                            taking this to closure, I know this was not easy to begin with.. we faced several
                            blockers right from discovery. I appreciate the team's perseverance throughout several
                            rounds of corrections & re-work. The team has run 10+ unification rules and validated
                            cases by region and by category (B2B and Individual owners). @Vishnu Kamath, @Ranjith
                            Rajmohan -
                            Your experience with Python and data helped here to expedite the transformation and
                            cleanup logic
                            for large data sets run analysis for the spread, and point out the gaps.</p>
                          <strong><i>- Anusha Vrushabendraswamy | Lead Technical Architect, Strategic Accounts
                              Excellence | Salesforce</i></strong>
                        </multiline>
                      </td> */}
                                          </tr>
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </layout>
          </layout>
          <table
            className="full"
            align="center"
            bgcolor="#333742"
            width="100%"
            border={0}
            cellSpacing={0}
            cellPadding={0}
          >
            <tbody>
              <tr>
                <td align="center">
                  <table
                    className="table-full"
                    width={600}
                    style={{ maxWidth: 600 }}
                    border={0}
                    align="center"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr>
                        <td bgcolor="#FFFFFF" align="center">
                          <table
                            className="table-inner"
                            width={550}
                            border={0}
                            align="center"
                            cellPadding={0}
                            cellSpacing={0}
                          >
                            <tbody>
                              <tr>
                                <td height={25} />
                              </tr>
                              <tr>
                                <td height={25} />
                              </tr>
                              <tr>
                                <td
                                  align="center"
                                  style={{
                                    fontFamily:
                                      "Century gothic,arial,sans-serif",
                                    fontSize: 24,
                                    color: "#4a4a4a",
                                    fontWeight: 100,
                                    lineHeight: "30px",
                                  }}
                                >
                                  <singleline label="title">
                                    Tech Trends                                   </singleline>
                                </td>
                              </tr>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td align="center">
                                  <table
                                    width={40}
                                    bgcolor="#FF0000"
                                    style={{ borderRadius: 10 }}
                                    border={0}
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          height={5}
                                          style={{ lineHeight: 0, fontSize: 0 }}
                                        >
                                          &nbsp;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td height={25} />
                              </tr>
                              <tr>
                                <td
                                  width={580}
                                  align="center"
                                  style={{
                                    fontFamily: "Open sans,arial,sans-serif",
                                    fontSize: 18,
                                    color: "red",
                                    lineHeight: "28px",
                                    fontWeight: 700,
                                    textAlign: "center",
                                  }}
                                >
                                  The Rise of Gen AI in Transforming Customer Experience
                                </td>
                              </tr>
                              <tr>
                                <td height={25} />
                              </tr>
                              <tr>
                                <td>
                                  <table
                                    width={150}
                                    className="table-full"
                                    border={0}
                                    align="left"
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          align="center"
                                          style={{ lineHeight: 0 }}
                                        >
                                          <img
                                            src={SushilGujarathi}
                                            width={150}
                                            alt="icon"
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  {/*[if (gte mso 9)|(IE)]>
                      </td>
                      <td>
                        <![endif]*/}
                                  <table
                                    width={25}
                                    align="left"
                                    border={0}
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td height={15} />
                                      </tr>
                                    </tbody>
                                  </table>
                                  {/*[if (gte mso 9)|(IE)]>
                      </td>
                      <td>
                        <![endif]*/}
                                  <table
                                    className="table-full"
                                    width={375}
                                    border={0}
                                    align="right"
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td height={125} />
                                      </tr>
                                      <tr>
                                        <td
                                          align="center"
                                          style={{
                                            border: "0 solid #fff",
                                            borderRadius: 4,
                                          }}
                                        >
                                          <table
                                            width="90%"
                                            border={0}
                                            align="left"
                                            cellPadding={0}
                                            cellSpacing={0}
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  valign="bottom"
                                                  style={{
                                                    fontFamily:
                                                      "Century gothic,arial,sans-serif",
                                                    fontSize: 24,
                                                    color: "#4a4a4a",
                                                    fontWeight: 100,
                                                    lineHeight: "30px",
                                                    textAlign: "left",
                                                  }}
                                                >
                                                  <p
                                                    style={{
                                                      color: "#000",
                                                      fontFamily:
                                                        "Century Gothic",
                                                      fontSize: 14,
                                                      fontStyle: "normal",
                                                      fontWeight: 400,
                                                      lineHeight: "normal",
                                                      marginBottom: 0,
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        color: "#000",
                                                        fontFamily:
                                                          "Century Gothic",
                                                        fontSize: 14,
                                                        fontStyle: "normal",
                                                        fontWeight: 700,
                                                        lineHeight: "normal",
                                                      }}
                                                    >
                                                      - Sushil Gujrathi, Chief Growth Officer
                                                    </span>
                                                  </p>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td height={10} />
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td height={10} />
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          {/* Tech Trends */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "24px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Today, Customer experience (CX) and Generative AI (Gen AI) are emerging as a game-changer for Chief Customer Officers (CCOs) and business leaders. By leveraging advanced algorithms, Gen AI not only personalizes customer interactions but also enhances operational efficiency, driving significant business outcomes.            <br />
                                              <br></br>
                                              Gen AI's capacity to analyze vast amounts of data enables organizations to gain deep insights into customer behavior and preferences. This data-driven approach allows businesses to create highly personalized experiences, tailoring products and services to meet individual needs. For instance, brands leveraging Gen AI can predict customer trends and preferences in real-time, thereby enhancing engagement and retention rates. A personalized experience leads to higher customer satisfaction, translating into increased loyalty and revenue growth.
                                              <br></br><br></br>
                                              Moreover, Gen AI streamlines customer service operations. By implementing AI-driven chatbots and virtual assistants, companies can offer 24/7 support, resolving queries instantly and freeing up human agents for more complex issues. This not only reduces operational costs but also ensures a consistent and efficient service experience. According to recent studies, businesses that adopt AI in customer service report a 30% reduction in handling time and a significant uptick in customer satisfaction scores.
                                              <br></br><br></br>
                                              Additionally, Gen AI fosters innovation in product development and marketing strategies. By simulating different scenarios and outcomes, businesses can optimize their offerings and marketing campaigns, ensuring that they resonate with their target audience. This agility allows companies to stay ahead of the competition and adapt quickly to market changes.
                                              <br></br><br></br>
                                              The rise of Gen AI in transforming customer experience is not just about technology; it's about driving strategic business outcomes. It is imperative for businesses to embrace this paradigm shift, leveraging Gen AI to create a more engaging, efficient, and customer-centric organization.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/* <layout label=quote>
<table class=full bgcolor=#333742 align=center width=100% border=0 cellspacing=0 cellpadding=0>
  <tr>
    <td align=center>
      <table class=table-full width=600 style=max-width:600px border=0 align=center cellpadding=0 cellspacing=0>
        <tr>
          <td bgcolor=#FFFFFF align=center>
            <table class=table-inner width=550 style=max-width:550px border=0 align=center cellpadding=0
              cellspacing=0>
              <tr>
                <td height=25></td>
              </tr>
              <tr>
                <td style="border:2px solid #d2d2d2" align=center>
                  <table class=table-inner width=500 border=0 align=center cellpadding=0 cellspacing=0>
                    <tr>
                      <td height=20></td>
                    </tr>
                    <tr>
                      <td align=center>
                        <table class=table-full width=375 border=0 align=left cellpadding=0 cellspacing=0>
                          <tr>
                            <td
                              style="font-family:Open sans,arial,sans-serif;font-size:16px;color:#9b9b9b;line-height:28px;font-weight:600">
                              <multiline label=quote><i>“Winning as a team is better than anything else. It’s
                                  great to share success”</i>
                                <br>
                                <span
                                  style="color:#9b9b9b;font-family:Century Gothic;font-size:14px;font-style:normal;font-weight:700;line-height:normal">
                                  <span
                                    style="color:#000;font-family:Century Gothic;font-size:14px;font-style:normal;font-weight:700;line-height:normal">-
                                    Jim Harbaugh, </span> American Football Coach</span>
                              </multiline>
                            </td>
                          </tr>
                        </table>
                        <table width=25 border=0 cellpadding=0 cellspacing=0 align=left>
                          <tr>
                            <td height=10></td>
                          </tr>
                        </table>
                        <table class=table-full width=100 border=0 align=right cellpadding=0 cellspacing=0>
                          <tr>
                            <td align=center style=line-height:0>
                              <img src=images/Jim-Harbaugh.jpg alt=img width=100
                                style=display:block;line-height:0;font-size:0px;border:0 editable label=image>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td height=20></td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td height=25></td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
    </layout> */}
          {/* Business Quote 2 */}
          <layout label="quote">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      className="table-full"
                      width={600}
                      style={{ maxWidth: 600 }}
                      border={0}
                      align="center"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td bgcolor="#FFFFFF" align="center">
                            <table
                              className="table-inner"
                              width={550}
                              style={{ maxWidth: 550 }}
                              border={0}
                              align="center"
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td
                                    style={{ border: "2px solid #d2d2d2" }}
                                    align="center"
                                  >
                                    <table
                                      className="table-inner"
                                      width={500}
                                      border={0}
                                      align="center"
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              className="table-full"
                                              width={375}
                                              border={0}
                                              align="left"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    style={{
                                                      fontFamily:
                                                        "Open sans,arial,sans-serif",
                                                      fontSize: 16,
                                                      color: "#9b9b9b",
                                                      lineHeight: "28px",
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    <multiline label="quote">
                                                      <i>
                                                        "Quality is the best business plan”
                                                      </i>
                                                      <br />
                                                      <br></br><br></br><br></br>
                                                      <span
                                                        style={{
                                                          color: "#9b9b9b",
                                                          fontFamily:
                                                            "Century Gothic",
                                                          fontSize: 14,
                                                          fontStyle: "normal",
                                                          fontWeight: 700,
                                                          lineHeight: "normal",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            color: "#000",
                                                            fontFamily:
                                                              "Century Gothic",
                                                            fontSize: 14,
                                                            fontStyle: "normal",
                                                            fontWeight: 700,
                                                            lineHeight:
                                                              "normal",
                                                          }}
                                                        >
                                                          - John Lasseter,
                                                        </span>{" "}
                                                        American Film Director                                     </span>
                                                    </multiline>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                            <table
                                              width={25}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                              align="left"
                                            >
                                              <tbody>
                                                <tr>
                                                  <td height={10} />
                                                </tr>
                                              </tbody>
                                            </table>
                                            <table
                                              className="table-full"
                                              width={100}
                                              border={0}
                                              align="right"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      src={BusinessQuote2}
                                                      alt="img"
                                                      width={100}
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                      }}
                                                      editable=""
                                                      label="image"
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          {/* Events & Celebrations */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Celebrating Excellence at Comsense
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>

                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Awards}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Comsense Quarterly Awards
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "left",
                                            }}
                                          >
                                            Rookie (Rising Star) Award:
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={5} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <strong>Ritu Shah.</strong> Ritu has quickly made her mark with her keen insights and dedication. Her fresh perspective is a valuable addition to our team.
                                              <br />
                                              <strong> Tejashri Kundalwal.</strong> Tejashri’s commitment to excellence and teamwork has set a new standard for rookies. Her hard work shines through every project she undertakes.
                                              <br />
                                              <strong>Payal Maisheri.</strong> Payal’s efforts in closing critical positions demonstrate her proactive approach and exceptional contributions to Comsense's growth.
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "left",
                                            }}
                                          >
                                            Star Performer Award:
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={5} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <strong>Shubham Vernekar.</strong>  Shubham has showcased outstanding dedication, balancing a heavy workload while continually innovating our processes for greater efficiency.
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "left",
                                            }}
                                          >
                                            Ace Contributors:
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={5} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <strong>Rohit Badave.</strong>  Rohit's tailored solutions have exceeded client expectations, proving his expertise and commitment to our collaborative success.
                                              <br />
                                              <strong>Tushar Rane.</strong> Tushar's unwavering dedication and ownership of his projects significantly enhance our client relationships and overall performance.
                                              <br />
                                              <strong>Umang Varshney.</strong> Umang has led key accounts with impressive stakeholder management skills, ensuring top-notch delivery and collaboration.
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>


                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "left",
                                            }}
                                          >
                                            Customer Delight Award      </td>
                                        </tr>
                                        <tr>
                                          <td height={5} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <strong>Rohit Kumar Khivasara.</strong>
                                              Rohit’s innovative solutions and dedication have truly fostered client delight, solidifying long-term partnerships.
                                              <br />
                                              <strong>Prajakta Patil.</strong>  Prajakta's commitment to understanding and solving client demands has made her an invaluable asset to our team.

                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>


                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "left",
                                            }}
                                          >
                                            Team Player Award
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={5} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <strong>Tanuj Chourasia.</strong> Tanuj’s extraordinary performance has inspired both clients and colleagues, elevating our team's success.
                                              <br />
                                              <strong>Sujeet Pawar.</strong> Sujeet consistently delivers high-quality work while motivating his peers, showcasing exceptional leadership.
                                              <br />
                                              <strong>Umesh Kolte Patil.</strong> Umesh's remarkable performance and dedication have played a pivotal role in driving the project's success.
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>



                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "left",
                                            }}
                                          >
                                            Administrative Excellence Award
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={5} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <strong>Sakshi Doddamani.</strong> Sakshi has excelled in managing organizational communication and marketing activities, significantly enhancing our internal and external presence.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>





                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Long Service Award
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              We are delighted to present the Long Service Award to <strong>Vaishnavi Patki</strong>, who has celebrated five incredible years with Comsense. Her unwavering dedication and belief in our mission have greatly contributed to our success. We extend our heartfelt gratitude for her commitment and look forward to many more fruitful years together!
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={LongServiceAward}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td height={50} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>


          {/* Associate Speak */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Associates Speak                                             </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              className="table-inner"
                                              style={{
                                                width: "100%!important",
                                                maxWidth: "100%!important",
                                              }}
                                              width={550}
                                              align="center"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td>
                                                    <table
                                                      className="table-full"
                                                      width={150}
                                                      align="left"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={25} />
                                                        </tr>
                                                        <tr>
                                                          <td height={15} />
                                                        </tr>
                                                        <tr>
                                                          <td
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight:
                                                                "28px",
                                                            }}
                                                          >
                                                            <img
                                                              src={Snehakshirsagar}
                                                              alt="img"
                                                              width={150}
                                                              style={{
                                                                display:
                                                                  "block",
                                                                lineHeight: 0,
                                                                fontSize: 0,
                                                                border: 0,
                                                                margin:
                                                                  "0 auto",
                                                              }}
                                                              editable=""
                                                              label="image"
                                                            />
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    {/*[if (gte mso 9)|(IE)]>

                                </td>

                                <td>

                                  <![endif]*/}
                                                    {/*[if (gte mso 9)|(IE)]>

                                </td>

                                <td>

                                  <![endif]*/}
                                                    <table
                                                      width={25}
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                      align="left"
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={15} />
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    <table
                                                      className="table-full"
                                                      width={370}
                                                      align="right"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={10} />
                                                        </tr>
                                                        <tr>
                                                          <td
                                                            align="center"
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight:
                                                                "28px",
                                                              textAlign:
                                                                "justify",
                                                            }}
                                                          >
                                                            <multiline label="content">
                                                              <span
                                                                style={{
                                                                  color:
                                                                    "#9b9b9b",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                  fontSize: 60,
                                                                  fontStyle:
                                                                    "normal",
                                                                  fontWeight: 400,
                                                                  lineHeight:
                                                                    "22px",
                                                                  letterSpacing:
                                                                    "-1.2px",
                                                                }}
                                                              >
                                                                “
                                                              </span>
                                                              For me, moving from an MNC to a mid-size company like Comsense has been a great experience. The team here is super supportive and friendly, and the culture feels dynamic and open. I have gotten to take on different responsibilities, which has been exciting, especially since I can actually see how my work makes an impact. Plus, the focus on work-life balance is awesome, making it a great place to grow and enjoy the work at the same time.
                                                              <br />
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "14px",
                                                                  color:
                                                                    "#9b9b9b",
                                                                  lineHeight:
                                                                    "28px",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                }}
                                                              >
                                                                <strong>
                                                                  Sneha Kshirsagar,
                                                                </strong>{" "}
                                                                BI Developer
                                                              </p>
                                                            </multiline>
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td height={25} />
                                                </tr>
                                                <tr>
                                                  <td height={10} />
                                                </tr>
                                              </tbody>
                                            </table>
                                            <table
                                              className="table-inner desktop-view"
                                              style={{
                                                width: "100%!important",
                                                maxWidth: "100%!important",
                                              }}
                                              width={550}
                                              align="center"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td>
                                                    <table
                                                      className="table-full"
                                                      width={370}
                                                      align="left"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={10} />
                                                        </tr>
                                                        <tr>
                                                          <td
                                                            align="center"
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight:
                                                                "28px",
                                                              textAlign:
                                                                "justify",
                                                            }}
                                                          >
                                                            <multiline label="content">
                                                              <span
                                                                style={{
                                                                  color:
                                                                    "#9b9b9b",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                  fontSize: 60,
                                                                  fontStyle:
                                                                    "normal",
                                                                  fontWeight: 400,
                                                                  lineHeight:
                                                                    "22px",
                                                                  letterSpacing:
                                                                    "-1.2px",
                                                                }}
                                                              >
                                                                “
                                                              </span>
                                                              Working at Comsense has been an incredibly fulfilling experience. The company fosters a great balance between professional growth and personal life, ensuring a healthy work-life balance. I’m trusted with the independence to make key decisions, which has empowered me to lead impactful projects and drive client success. The collaborative environment encourages innovation, and the leadership is always supportive, providing the resources needed to succeed. It’s a place where you’re given the freedom to grow, both as a professional and an individual, and I’m proud to be part of this journey.
                                                              <br />
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "14px",
                                                                  color:
                                                                    "#9b9b9b",
                                                                  lineHeight:
                                                                    "28px",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                }}
                                                              >
                                                                <strong>
                                                                  - Umang Varshney,
                                                                </strong>
                                                                Account Manager
                                                              </p>
                                                            </multiline>
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    <table
                                                      width={25}
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                      align="left"
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={30} />
                                                        </tr>
                                                        <tr>
                                                          <td height={5} />
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    <table
                                                      className="table-full"
                                                      width={150}
                                                      align="right"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight: 28,
                                                            }}
                                                          >
                                                            <img
                                                              src={Umang}
                                                              alt="img"
                                                              width={150}
                                                              style={{
                                                                display:
                                                                  "block",
                                                                lineHeight: 0,
                                                                fontSize: 0,
                                                                border: 0,
                                                                margin:
                                                                  "0 auto",
                                                              }}
                                                              editable=""
                                                              label="image"
                                                            />
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td height={25} />
                                                </tr>

                                              </tbody>
                                            </table>
                                            <table
                                              className="table-inner mobile-responsive"
                                              style={{
                                                width: "100%!important",
                                                maxWidth: "100%!important",
                                              }}
                                              width={550}
                                              align="center"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td>
                                                    <table
                                                      className="table-full"
                                                      width={150}
                                                      align="left"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight: 28,
                                                            }}
                                                          >
                                                            <img
                                                              // src={rohit}
                                                              src={Umang}
                                                              alt="img"
                                                              width={150}
                                                              style={{
                                                                display:
                                                                  "block",
                                                                lineHeight: 0,
                                                                fontSize: 0,
                                                                border: 0,
                                                                margin:
                                                                  "0 auto",
                                                              }}
                                                              editable=""
                                                              label="image"
                                                            />
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    {/*[if (gte mso 9)|(IE)]>

                                </td>

                                <td>

                                  <![endif]*/}
                                                    {/*[if (gte mso 9)|(IE)]>

                                </td>

                                <td>

                                  <![endif]*/}
                                                    <table
                                                      width={25}
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                      align="left"
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={15} />
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    <table
                                                      className="table-full"
                                                      width={370}
                                                      align="right"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={10} />
                                                        </tr>
                                                        <tr>
                                                          <td
                                                            align="center"
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight:
                                                                "28px",
                                                              textAlign:
                                                                "justify",
                                                            }}
                                                          >
                                                            <multiline label="content">
                                                              <span
                                                                style={{
                                                                  color:
                                                                    "#9b9b9b",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                  fontSize: 60,
                                                                  fontStyle:
                                                                    "normal",
                                                                  fontWeight: 400,
                                                                  lineHeight:
                                                                    "22px",
                                                                  letterSpacing:
                                                                    "-1.2px",
                                                                }}
                                                              >
                                                                “
                                                              </span>
                                                              Comsense has been
                                                              a great place for
                                                              me to kickstart my
                                                              career. The
                                                              learning curve has
                                                              been steep, but
                                                              incredibly
                                                              rewarding. I’ve
                                                              grown so much,
                                                              both
                                                              professionally and
                                                              personally. What I
                                                              love most is how
                                                              innovation is
                                                              always at the core
                                                              of what we do,
                                                              which keeps the
                                                              work exciting and
                                                              future-focused.
                                                              The culture here
                                                              is engaging and
                                                              collaborative, and
                                                              every
                                                              milestone—big or
                                                              small—is
                                                              celebrated. That
                                                              recognition not
                                                              only builds a
                                                              sense of
                                                              accomplishment but
                                                              also motivates me
                                                              to push further
                                                              and aim higher.
                                                              <br />
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "14px",
                                                                  color:
                                                                    "#9b9b9b",
                                                                  lineHeight:
                                                                    "28px",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                }}
                                                              >
                                                                <strong>
                                                                  - Juhi Shah
                                                                </strong>
                                                                , Trainee
                                                                software
                                                                engineer{" "}
                                                              </p>
                                                            </multiline>
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td height={25} />
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              className="table-inner"
                                              width={500}
                                              border={0}
                                              align="left"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td align="center"></td>
                                                </tr>
                                                <tr>
                                                  <td height={20} />
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/* Welcome Aboard */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Welcome Aboard
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={joinees}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              The last quarter brought several new talents to the Comsense family. We are thrilled to welcome Sapna Date, Akshay Waghmare, Rutuja Rajput, Drishti Wahi, Sanika Kadam, Pranali Rashinkar, Pooja Singh, Rupesh Bhosale, and Radha Kulkarni.hti Labade, Ishita Sharma, Rohit Deshmukh, Shantanu Sharma, and Charushila Kunwar
                                              <br />
                                              <br />
                                              We wish them all a successful and fulfilling career journey with us!
                                            </multiline>
                                          </td>
                                        </tr>

                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <br />
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              {" "}
                                              Events and Celebrations {" "}
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={40} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Outing}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <br />
                                              <strong>The Much-Awaited Comsense Annual Outing Was a Mesmerizing Experience</strong>
                                              Our annual office trip to Mahabaleshwar was an unforgettable experience, especially in the midst of the monsoons! The entire team enjoyed exciting games like tug-of-war and brought back some old favorites like the three-legged race relay. The evening was filled with fun as we hit the dance floor, enjoyed cocktails, and even had some impromptu singing sessions. Everyone savored the delicious food and thoroughly enjoyed the stay but what stood out the best was the memories we made. Hoping for deeper team connections for the coming year.

                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>


          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <br />
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={30} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Birthday Celebrations
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={40} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={BirthdayCelebration}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <br />
                                              At Comsense, we cherish every opportunity to celebrate our team members, and birthdays are a special way to express our appreciation for each individual.
                                              MIn July and August, we celebrated the birthdays of Shreepad, Umesh, Abhishek, Wasim, Neha, Rohit, Tanuj, Abhishek S, Sujeet, Rutuja, Shubham, Dipali, Rakhi, Savita, and Kishore.
                                              <br></br>
                                              Happy birthday to all! Your contributions make Comsense a vibrant place to work, and we look forward to celebrating many more joyful moments together.
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          {/* Spiritual Corner */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <br />
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Spiritual Corner
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={SpritualEvent}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <br></br>
                                              <strong> Meditation Week</strong>
                                              <br />
                                              In the last quarter, we initiated meditation sessions for our employees to help them relax during work hours. Over three days, we hosted a workshop led by Heartfulness trainers, focusing on techniques to declutter the mind and improve concentration through yogic transmission. In addition to our regular Wednesday group sessions, we dedicated a Meditation Week to boost participation and foster consistent meditation practice. This initiative significantly contributed to promoting inner harmony and well-being within our workplace!
                                              <br />
                                              <br />
                                              Heartfulness is a path of experiencing our inner self. It's simple and subtle practice of meditation connects each of us with the light and love that is present in our hearts. It teaches us to dive deep into our heart, and be in a natural state of love, peace, and calmness. Our daily practices, help awaken our inherent potential for simple, balanced and joyful existence.When practiced regularly, meditation helps us become in tune with our heart and develop the capacity to remain poised and balanced at all times.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "left",
                                            }}
                                          >
                                            <multiline label="content">
                                              <br></br>
                                              <a
                                                href="https://heartfulness.org/in/"
                                                target="_blank"
                                                style={{
                                                  color: "#9b9b9b",
                                                  fontFamily: "Open Sans",
                                                  fontSize: 14,
                                                  fontStyle: "normal",
                                                  fontWeight: 700,
                                                  lineHeight: "22px",
                                                  letterSpacing: "-.28px",
                                                  textDecorationLine:
                                                    "underline",
                                                  textAlign: "left !important",
                                                }} rel="noreferrer"
                                              >
                                                More about Heartfulness:
                                                www.heartfulness.org
                                                <br />
                                                <br />
                                              </a>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          <table
            className="full"
            bgcolor="#333742"
            align="center"
            width="100%"
            border={0}
            cellSpacing={0}
            cellPadding={0}
          >
            <tbody>
              <tr>
                <td align="center">
                  <table
                    className="table-full"
                    width={600}
                    style={{ maxWidth: 600 }}
                    border={0}
                    align="center"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr>
                        <td
                          align="center"
                          background={city}
                          bgcolor="#515663"
                          style={{
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                          }}
                        >
                          <table
                            align="center"
                            width="95%"
                            border={0}
                            cellSpacing={0}
                            cellPadding={0}
                          >
                            <tbody>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td
                                  align="center"
                                  style={{
                                    fontFamily:
                                      "Century gothic,arial,sans-serif",
                                    fontSize: 22,
                                    fontWeight: 600,
                                    lineHeight: "30px",
                                    color: "#fff",
                                    letterSpacing: 1,
                                  }}
                                >
                                  Thanks for reading.
                                  <br />
                                  <span
                                    style={{
                                      fontFamily:
                                        "Century gothic,arial,sans-serif",
                                      fontSize: 14,
                                      fontWeight: 400,
                                      color: "#fff",
                                      letterSpacing: 1,
                                    }}
                                  >
                                    Did someone share this with you?{" "}
                                    <a
                                      style={{ color: "#fff" }}
                                      href="https://www.comsenseconsulting.com/newsletter/subscribe.html"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <u>Sign up</u>
                                    </a>{" "}
                                    here.
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td height={15} />
                              </tr>
                              <tr>
                                <td align="center">
                                  <table
                                    align="center"
                                    border={0}
                                    cellSpacing={0}
                                    cellPadding={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          bgcolor="#FF0000"
                                          height={40}
                                          style={{
                                            fontFamily:
                                              "Century Gothic,sans-serif",
                                            fontSize: 14,
                                            color: "#4a4a4a",
                                            fontWeight: 700,
                                            paddingLeft: 15,
                                            paddingRight: 16,
                                            letterSpacing: "1.5px",
                                          }}
                                        >
                                          <a
                                            href="https://www.comsensetechnologies.com/newsletter/subscribe.html"
                                            style={{
                                              textDecoration: "none",
                                              color: "#fff",
                                              borderRadius: 5,
                                            }}
                                            target="_blank" rel="noreferrer"
                                          >
                                            SUBSCRIBE
                                          </a>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    fontFamily:
                                      "Century gothic,arial,sans-serif",
                                    fontSize: 11,
                                    fontWeight: 400,
                                    color: "#fff",
                                    letterSpacing: 1,
                                    textAlign: "center",
                                  }}
                                >
                                  <br />
                                  If you liked this Newsletter, please recommend
                                  it to someone you know.
                                  <br />
                                  Or why not even share it on Twitter or
                                  Linkedin? … enough right?
                                  <br />
                                  If you don’t want to receive future
                                  Newsletters, please click here to{" "}
                                  <a
                                    style={{ color: "#fff" }}
                                    href="https://www.comsensetechnologies.com/newsletter/unsubscribe.html"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <u>unsubscribe</u>
                                  </a>
                                  .<br />
                                  We will miss you!
                                  <br />
                                  <br />
                                  {/* View April 2024 Newsletter Here <a style=color:#fff
                  href=https://comsensetechnologies.com/wp-content/newsletter/april-2024/
                  target=_blank><u>here</u></a>. */}
                                </td>
                              </tr>
                              <tr>
                                <td height={20} />
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </repeater>
        <table
          className="full"
          bgcolor="#333742"
          align="center"
          width="100%"
          border={0}
          cellSpacing={0}
          cellPadding={0}
        >
          <tbody>
            <tr>
              <td align="center">
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td bgcolor="#FFFFFF" align="center">
                        <table
                          className="table-inner"
                          width={550}
                          style={{ maxWidth: 550 }}
                          border={0}
                          align="center"
                          cellPadding={0}
                          cellSpacing={0}
                        >
                          <tbody>
                            <tr>
                              <td height={25} />
                            </tr>
                            <tr>
                              <td
                                align="center"
                                style={{
                                  fontFamily: '"Open sans",Arial,sans-serif',
                                  color: "#4a4a4a",
                                  fontSize: 16,
                                }}
                              >
                                FOLLOW US
                              </td>
                            </tr>
                            <tr>
                              <td height={25} />
                            </tr>
                            <tr>
                              <td>
                                <table
                                  className="table-full"
                                  border={0}
                                  align="center"
                                  cellPadding={0}
                                  cellSpacing={0}
                                >
                                  <tbody>
                                    <tr>
                                      <td>
                                        <table
                                          border={0}
                                          align="center"
                                          cellPadding={0}
                                          cellSpacing={0}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.facebook.com/Comsenseconsulting/"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={fb1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-1"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                                target="_blank"
                                              >
                                                <a href="https://twitter.com/ComsenseTech">
                                                  <img
                                                    src={tw1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-2"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="http://linkedin.com/company/comsense-consulting"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={ln1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-3"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.instagram.com/comsensemktg/"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={ig1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-4"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.youtube.com/channel/UCCekynsEDZS7VORzB5KwX9g"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={yt1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-5"
                                                  />
                                                </a>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td height={25} />
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td height={5} bgcolor="#FF0000" />
                    </tr>
                  </tbody>
                </table>
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td height={25} />
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    </>
  );
};

export default October;
